// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HAdC","title":"styles_title__2pODf"};